import type { Company } from "kubb";
import type { Scheme } from "kubb";
import React from "react";
import { useSelectedCompany } from "../hooks/useCompany";
import { useSelectedScheme } from "../hooks/useScheme";

export type SetTitleFunction = (props: {
  company: Company | undefined;
  scheme: Scheme | undefined;
}) => string;

interface setPageTitleProps {
  setPageTitle?: SetTitleFunction;
}

export function companyObjectPageTitle(entityName: string): SetTitleFunction {
  return ({ company }) => entityName + (company ? `: ${company.name}` : "");
}

export function schemeObjectPageTitle(
  entityName: string,
  schemeFirst = false,
): SetTitleFunction {
  return ({ scheme }) =>
    schemeFirst
      ? (scheme ? `${scheme.scheme_name}: ` : "") + entityName
      : entityName + (scheme ? `: ${scheme.scheme_name}` : "");
}

export default function useSetPageTitle({ setPageTitle }: setPageTitleProps) {
  const company = useSelectedCompany();
  const scheme = useSelectedScheme();

  return React.useEffect(() => {
    document.title = setPageTitle
      ? setPageTitle({ company, scheme })
      : "Meterpoint";
    return () => {
      document.title = "Meterpoint";
    };
  }, [company, scheme, setPageTitle]);
}
